'use strict';

import loadWhenNeeded from '../Utils/LoadWhenNeeded';

/**
 * @classname LazyBackground
 * @classdesc 画面外のCSS背景画像（街並みイラスト）を初期表示の後に読み込む
 */
export default class LazyBackground {
	/**
	 * @constructor
	 * @param {jQuery} $e - [data-lazy-bg]
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor`);
		const element = $e[0];
		loadWhenNeeded(element, () => element.classList.add('is-bg-loaded'));
	};
};
